/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

class FileUploadBundle {
  constructor(data) {
    this.data = _.assign({}, {
      file: {},
      rawFile: null,
    }, data);
  }


}

export default FileUploadBundle;
